import { ReactElement } from 'react'
import { Content, Modal, Typography, Button } from './styles'
import { useHistory } from 'react-router-dom'

type TProps = {
  open: boolean
  onClose: () => void
}

const ModalParceiro = ({ open, onClose }: TProps): ReactElement => {
  const history = useHistory()
  return (
    <Modal
      title="Necessário criação de conta no Tmov Pay!"
      size="sm"
      open={open}
      onClose={onClose}
      hideCloseButton={true}
    >
      <Content>
        <Typography variant="p1">
          Para encaminhar os lotes e fazer as validações da pagamento e
          recebimento é necessário finalizar sua abertura de conta no Tmov Pay.
        </Typography>
        <Button variant="outlined" size="lg" onClick={() => history.push('/')}>
          sair
        </Button>
        <Button variant="contained" size="lg" onClick={onClose}>
          Concordo
        </Button>
      </Content>
    </Modal>
  )
}

export default ModalParceiro
